<div class="carousel-block">
  <button class="carousel-header" (click)="toggleAccordion()">
    <h4 class="carousel-title">Included videos</h4>
    <button class="accordion-button">
      <outlaw-icon name="triangleChevron" size="8px" class="triangle-chevron" [class.open]="!isOpen()"></outlaw-icon>
    </button>
  </button>

  <div [@accordionAnimation]="isOpen() ? 'open' : 'closed'" class="accordion-content">
    <outlaw-carousel [slides]="videos" [config]="carouselConfig">
      <ng-template let-video>
        <outlaw-playlist-item
          [video]="video"
          [isSelected]="selectedVideo?.id === video.id"
          (itemClick)="onVideoClick(video)"
        />
      </ng-template>
    </outlaw-carousel>

    @if (selectedVideo) {
      <div class="playlist-info">
        <div class="playlist-text-info">
          <div class="playlist-name">
            {{ selectedVideo.name }}
          </div>
          <div class="playlist-description" [outlawTextTruncate]="2" #description="outlawTextTruncate">
            {{ selectedVideo.description }}
          </div>
        </div>

        @if (canDisplayTrailerButton()) {
          <button class="playlist-play-button" (click)="onTrailerClick()">
            <outlaw-icon class="icon-svg" name="circlePlay" />
            <span class="playlist-play-button-text">Trailer</span>
          </button>
        }
      </div>
    }
  </div>
</div>
